import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LazyAssetLazyComponent } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';

@Component({
    selector: 'app-lazy-asset',
    templateUrl: './lazy-asset.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, LazyAssetLazyComponent],
})
export class LazyAssetComponent extends LazyAssetLazyComponent {}
